import themeGet from '@styled-system/theme-get';
import React from 'react';
import styled, { css, keyframes } from 'styled-components';
import { Box } from '../Box/Box';
import { Flex } from '../Flex/Flex';
import { applySizes } from '../utils/utils';
/**
 * @public
 */
export const dotLoaderSizes = {
  small: css(["height:18px;& > *{width:8px;height:8px;}& > :not(:last-child){margin-right:", "px;}"], themeGet('space.3')),
  medium: css(["height:21px;& > *{width:12px;height:12px;}& > :not(:last-child){margin-right:", "px;}"], themeGet('space.4')),
  large: css(["height:24px;& > *{width:16px;height:16px;}& > :not(:last-child){margin-right:", "px;}"], themeGet('space.4'))
};
/**
 * @public
 */
export const dotLoaderSpeeds = {
  slow: 2.5,
  medium: 2,
  fast: 1
};
const getDelay = (duration, pos = 0) => {
  return `${duration / 6 * pos}s;`;
};
const animation = /*#__PURE__*/keyframes(["0%,20%,100%{transform:translateY(50%) scale(0);}50%{transform:translateY(-50%) scale(1);}"]);
const Container = /*#__PURE__*/styled(Flex).withConfig({
  displayName: "DotLoader__Container",
  componentId: "sc-1vwwcjc-0"
})(["justify-content:center;align-items:center;", ";"], applySizes(dotLoaderSizes, null));
const Dot = /*#__PURE__*/styled(Box).withConfig({
  displayName: "DotLoader__Dot",
  componentId: "sc-1vwwcjc-1"
})(["border-radius:50%;transform:scale(0);transform-origin:center;animation:", " ", "s ease infinite;animation-delay:", "s;"], animation, props => props.duration, props => getDelay(props.duration, props.pos));
/**
 * @public
 */
export function DotLoader({
  color,
  size,
  speed,
  ...props
}) {
  const duration = dotLoaderSpeeds[speed];
  return React.createElement(Container, {
    size: size,
    ...props
  }, React.createElement(Dot, {
    color: color,
    duration: duration
  }), React.createElement(Dot, {
    color: color,
    duration: duration,
    pos: 1
  }), React.createElement(Dot, {
    color: color,
    duration: duration,
    pos: 2
  }));
}
DotLoader.defaultProps = {
  color: 'primary',
  size: 'medium',
  speed: 'medium'
};